import type { HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { SnackbarService } from '../snackbar.service';
import { inject } from '@angular/core';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackbarService = inject(SnackbarService);

  return next(req).pipe(
    catchError(response => {
      if (response.status === 403) {
        snackbarService.showError('error.forbidden');
      } else if (response.error?.message === 'Validation error') {
        snackbarService.showError('error.commonValidation');
      } else {
        snackbarService.showApiError(response);
      }

      return throwError(() => response);
    }),
  );
};
